var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNameLite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 187.499995",
    height: 250,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("g", null), /*#__PURE__*/React.createElement("clipPath", {
    id: "570e7a01e9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 106 L 10 106 L 10 129 L 0.5 129 Z M 0.5 106 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "363df094df"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 64 L 10 64 L 10 88 L 0.5 88 Z M 0.5 64 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f43f194a7c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 119 L 44 119 L 44 129 L 0.5 129 Z M 0.5 119 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "47303e6ff4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 92 L 44 92 L 44 102 L 0.5 102 Z M 0.5 92 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6ed49504b4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.5 64 L 44 64 L 44 74 L 0.5 74 Z M 0.5 64 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.993308, 127.035704)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.796875 -40.1875 L 16.046875 -33.4375 L 16.046875 0 L 6.59375 0 L 6.59375 -62.140625 L 7.765625 -62.140625 L 44.25 -21.453125 L 43.90625 -28.546875 L 43.90625 -62.0625 L 53.359375 -62.0625 L 53.359375 0 L 52.09375 0 Z M 15.796875 -40.1875 "
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(110.176838, 126.911647)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M -1.34375 -62.0625 L 9.375 -62.0625 L 27.953125 -19.421875 L 46.609375 -62.0625 L 57.25 -62.0625 L 28.625 0 L 27.359375 0 Z M -1.34375 -62.0625 "
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(174.47486, 126.911647)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.6875 -62.0625 L 17.140625 -62.0625 L 17.140625 0 L 7.6875 0 Z M 7.6875 -62.0625 "
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(241.171529, 126.911647)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 35.125 0.84375 C 29.5 0.84375 24.304688 -0.460938 19.546875 -3.078125 C 14.785156 -5.703125 11 -9.429688 8.1875 -14.265625 C 5.375 -19.109375 3.96875 -24.738281 3.96875 -31.15625 C 3.96875 -37.632812 5.375 -43.28125 8.1875 -48.09375 C 11 -52.90625 14.785156 -56.601562 19.546875 -59.1875 C 24.304688 -61.78125 29.5 -63.078125 35.125 -63.078125 C 40.75 -63.078125 45.941406 -61.78125 50.703125 -59.1875 C 55.460938 -56.601562 59.25 -52.90625 62.0625 -48.09375 C 64.875 -43.28125 66.28125 -37.632812 66.28125 -31.15625 C 66.28125 -24.738281 64.875 -19.109375 62.0625 -14.265625 C 59.25 -9.429688 55.460938 -5.703125 50.703125 -3.078125 C 45.941406 -0.460938 40.75 0.84375 35.125 0.84375 Z M 35.125 -7.6875 C 39.007812 -7.6875 42.554688 -8.597656 45.765625 -10.421875 C 48.972656 -12.253906 51.519531 -14.929688 53.40625 -18.453125 C 55.289062 -21.972656 56.234375 -26.179688 56.234375 -31.078125 C 56.234375 -36.023438 55.289062 -40.257812 53.40625 -43.78125 C 51.519531 -47.300781 48.984375 -49.960938 45.796875 -51.765625 C 42.617188 -53.566406 39.0625 -54.46875 35.125 -54.46875 C 31.1875 -54.46875 27.613281 -53.566406 24.40625 -51.765625 C 21.195312 -49.960938 18.660156 -47.300781 16.796875 -43.78125 C 14.941406 -40.257812 14.015625 -36.023438 14.015625 -31.078125 C 14.015625 -26.179688 14.972656 -21.972656 16.890625 -18.453125 C 18.804688 -14.929688 21.378906 -12.253906 24.609375 -10.421875 C 27.847656 -8.597656 31.351562 -7.6875 35.125 -7.6875 Z M 35.125 -7.6875 "
  }))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(207.205897, 126.911647)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 7.6875 -62.0625 L 17.140625 -62.0625 L 17.140625 0 L 7.6875 0 Z M 7.6875 -62.0625 "
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(319.665376, 127.035704)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M 15.796875 -40.1875 L 16.046875 -33.4375 L 16.046875 0 L 6.59375 0 L 6.59375 -62.140625 L 7.765625 -62.140625 L 44.25 -21.453125 L 43.90625 -28.546875 L 43.90625 -62.0625 L 53.359375 -62.0625 L 53.359375 0 L 52.09375 0 Z M 15.796875 -40.1875 "
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#570e7a01e9)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.000000000000000046, 0.161147, -0.161147, 0.000000000000000046, 9.539039, 111.232847)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00948031 27.997339 L 81.99 27.997339 ",
    stroke: "#ffffff",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#363df094df)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0, 0.161147, -0.161147, 0, 9.539039, 69.334552)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00859897 27.997339 L 81.989119 27.997339 ",
    stroke: "#ffffff",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f43f194a7c)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.161158, 0, 0, 0.161147, 0.498675, 119.934798)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00821866 27.990012 L 237.98332 27.990012 ",
    stroke: "#ffffff",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#47303e6ff4)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.161126, 0, 0, 0.161147, 0.498675, 92.378615)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00822028 27.999297 L 238.030207 27.999297 ",
    stroke: "#ffffff",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6ed49504b4)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(0.161158, 0, 0, 0.161147, 0.498675, 64.822421)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 0.00821866 28.008641 L 237.98332 28.008641 ",
    stroke: "#ffffff",
    strokeWidth: 56,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNameLite);
export default __webpack_public_path__ + "static/media/nameLite.6a2dbcc7fb7201bd215e049fcc556f5a.svg";
export { ForwardRef as ReactComponent };